export interface queryParam {
  pageSize?: string;
  pageNo?: string;
  query?: string;
  pageIndex?: string;
}

export const defaultQueryParam: queryParam = {
  pageSize: '20',
  pageIndex: '0'
};

export const AGENCY_TABLE = 'agenciesTable';
